import type ApplicationInstance from "@ember/application/instance";
import { getOwner } from "@ember/owner";
import Service, { service } from "@ember/service";
import { tracked } from "@glimmer/tracking";
import type CoreAdapter from "parog-web/adapters/core";
import ControlTower from "wise-control-tower";
import type SemeiaSessionService from "./session";

export default class BioExamResultsService extends Service {
  @service requestManager;
  @service declare session: SemeiaSessionService;

  @tracked declare bioExamToReviewCount: number;

  applicationAdapter = (getOwner(this) as ApplicationInstance).lookup(
    "adapter:application"
  ) as CoreAdapter;

  async loadBioExamToReviewCount(): Promise<void> {
    if (this.session.medic?.isSuperUser) {
      const response = await fetch("/api/v1/count_bio_jes_to_review", {
        headers: Object.assign(
          {
            "Content-Type": "application/json"
          },
          this.applicationAdapter.headers
        )
      });
      if (!response.ok) {
        ControlTower.captureException(response.text);
        this.bioExamToReviewCount = 0;
      }
      const content = await response.json();
      this.bioExamToReviewCount = content.count;
    }
  }
}

declare module "@ember/service" {
  interface Registry {
    bioExamResults: BioExamResultsService;
  }
}
